<template>
  <v-container class="notification">
    <header class="pa-4 d-flex align-center justify-space-between">
      <ActionButton
        :block="false"
        actionIcon="$sl-save"
        @click="$emit('readNotes')"
      >
        {{ $t('notifications.mark-read') }}
      </ActionButton>

      <v-icon class="mt-1" small @click="$emit('close')">$sl-close</v-icon>
    </header>

    <NotificationList @clickNote="$events.fire('readNote', arguments[0])" @closeModal="$emit('close')" />

    <div class="d-flex align-center justify-space-between pa-4" style="gap: 8px;">
      <ActionButton style="flex: 1 1 0 !important;" @click="$emit('showSettings')">
        <v-icon>$sl-settings</v-icon>
        {{ $t('settings.settings-title') }}
      </ActionButton>

      <ActionButton style="flex: 1 1 0 !important;" @click="$emit('showNotes')">
        <v-icon>$sl-bullets</v-icon>
        {{ $t('notifications.show-all') }}
      </ActionButton>
    </div>
  </v-container>
</template>

<script>
import NotificationList from '@/components/Notifications/NotificationList'
import ActionButton from "@/components/Common/ActionButton";

// @group Notifications
// NotificationDialog component
export default {
  name: 'NotificationDialog',
  components: {
    NotificationList,
    ActionButton
  }
}
</script>
